const TmpMassUploadKeys = {

	//------------MASS UPLOAD------------------
	TMP_MASS_UPLOAD: "tmpMassUpload",
	TMP_MASS_UPLOAD_TITLE: "tmpMassUploadTitle",
	TMP_MASS_DOWNLOAD_TEMPLATE: "tmpMassDownloadTemplate",
	TMP_MASS_UPLOAD_BUTTON: "tmpMassUploadButton"
}

export default TmpMassUploadKeys